<div
    class="cipo-bg--accent-100 cipo-reverse-container p-a"
    [fxLayout]="compactMode() ? 'column' : 'row'"
    fxLayout.lt-lg="column"
    fxLayoutGap="12px"
    data-testid="doc-notification-form">
    <cipo-select
        fxFlex
        [control]="form.controls.notify"
        [fieldData]="mappedFieldsData().notify"
        data-testid="doc-notification-form-notify-select" />
    <cipo-select
        fxFlex
        [control]="form.controls.excludeRoles"
        [fieldData]="mappedFieldsData().excludeRoles"
        data-testid="doc-notification-form-exclude-roles-select" />
    @if (!data().hideIncludeAttachments) {
        <cipo-checkbox
            fxFlex="none"
            [control]="form.controls.includeAttachments"
            [fieldData]="mappedFieldsData().includeAttachments"
            data-testid="doc-notification-form-include-attachments-checkbox" />
    }
</div>
